import React from "react"
import cx from "classnames"
import classes from "./styles.module.scss"
import Video from "./video"
import { Link } from "gatsby"
import LinkButton from "../link-button"
import {FaVideo} from "react-icons/fa"
import {MdCameraEnhance} from "react-icons/md"

interface Props {
  heroBackgroundImage: any
  heroVideoURL: string
  heroH1: string
  heroH2: string
  heroText: string
  heroCTAText?: string
	heroCTALink?: string
	heroCaption?: string
}

const Hero: React.FC<Props> = ({
  heroBackgroundImage,
  heroVideoURL,
  heroH1,
  heroH2,
  heroText,
  heroCTAText,
	heroCTALink,
	heroCaption
}) => {
  
  const bgImage =
    heroBackgroundImage?.data?.resolutions?.src ?? heroBackgroundImage ?? ""
  return (
    <div
      className={cx(classes.Container)}
      style={{backgroundImage: `url("${bgImage}")`}}
    >
      <Video videoURL={heroVideoURL} />

      <div className={cx(classes.Content)}>
        <div className={cx(classes.SubContent)}>
          <h1>{heroH1}</h1>
          <h2>{heroH2}</h2>
          <p>{heroText}</p>
          {heroCTALink && heroCTAText ? (
            <LinkButton link={heroCTALink} text={heroCTAText} />
          ) : null}
        </div>
        <div className={cx(classes.Caption)}>
          <p>
            <MdCameraEnhance  /> {heroCaption}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Hero
